var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logo" },
    [
      _c("a-icon", {
        staticStyle: { "margin-right": "20px", color: "white" },
        attrs: { type: "menu-fold" },
        on: {
          click: function($event) {
            return _vm.handleClick()
          }
        }
      }),
      _c("a", { staticStyle: { flex: "1", "margin-right": "20px" } }),
      _c(
        "a-drawer",
        {
          attrs: {
            title: this.$store.getters.language["system.switchSystem"],
            placement: _vm.placement,
            closable: false,
            visible: _vm.visible
          },
          on: { close: _vm.onClose }
        },
        [
          [
            _c("a-list", {
              attrs: {
                "item-layout": "horizontal",
                "data-source": _vm.dataSource
              },
              scopedSlots: _vm._u([
                {
                  key: "renderItem",
                  fn: function(item, index) {
                    return _c(
                      "a-list-item",
                      {},
                      [
                        _c(
                          "a-list-item-meta",
                          [
                            _c(
                              "a",
                              {
                                attrs: { slot: "title" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleJump(item)
                                  }
                                },
                                slot: "title"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.applicationNameLanguage
                                      ? item.applicationNameLanguage
                                      : item.applicationName
                                  )
                                )
                              ]
                            ),
                            _c("a-avatar", {
                              attrs: {
                                slot: "avatar",
                                src: _vm.getAvatarView(item.applicationImgPath)
                              },
                              slot: "avatar"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ])
            })
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }